import React from 'react'
import { ViewTitle, SimpleShowLayout } from 'admin-on-rest'
import { CourseView } from '../components/CourseView'
import { StudentCourseCompletedStatus } from '../components/StudentCourseCompletedStatus'

export default class StudentCoursePageInProgress extends React.Component {
  render() {
    const { course } = this.props
    // console.log('course in progress', course)
    if (!course) return null

    return (
      <div>
        <ViewTitle
          title={`Detalii despre cursul in desfasurare '${course.name}'`}
        />
        <SimpleShowLayout record={course}>
          <CourseView />
          <StudentCourseCompletedStatus course={course} />
        </SimpleShowLayout>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/students/StudentCoursePageInProgress.js